(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bek-faq-guide"] && !Shopify.designMode) return;
  try {
    
function initializeFaqGuide(scope) {
  scope.querySelectorAll('[data-faq-guide]').forEach(function (root) {
    if (root.dataset.faqReady) return;
    root.dataset.faqReady = 'true';
    var input = root.querySelector('[data-faq-search]');
    var items = Array.from(root.querySelectorAll('[data-faq-item]'));
    var topics = Array.from(root.querySelectorAll('[data-faq-topic]'));
    var empty = root.querySelector('[data-faq-empty]');
    root.querySelector('[data-faq-search-wrap]').hidden = false;
    function filter() {
      var terms = input.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      var matches = 0;
      items.forEach(function (item) {
        var text = item.textContent.toLocaleLowerCase();
        var show = terms.every(function (term) { return text.indexOf(term) !== -1; });
        item.hidden = !show;
        item.open = terms.length > 0 && show;
        if (show) matches++;
      });
      topics.forEach(function (topic) {
        var el = topic.nextElementSibling;
        var show = false;
        while (el && !el.hasAttribute('data-faq-topic')) {
          if (el.hasAttribute('data-faq-item') && !el.hidden) show = true;
          el = el.nextElementSibling;
        }
        topic.hidden = !show;
      });
      empty.hidden = matches !== 0;
    }
    input.addEventListener('input', filter);
    root.querySelectorAll('[data-faq-jump]').forEach(function (link) {
      link.addEventListener('click', function () {
        input.value = '';
        items.forEach(function (item) { item.open = false; });
        filter();
      });
    });
  });
}
initializeFaqGuide(document);
document.addEventListener('shopify:section:load', function (event) { initializeFaqGuide(event.target); });
document.addEventListener('shopify:block:select', function (event) {
  var item = event.target.closest('[data-faq-item]');
  if (item) { item.hidden = false; item.open = true; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-kaminspezialist"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var section = document.getElementById('kaminspezialist-contact-{{ section.id }}');
  if (!section) return;

  var elements = section.querySelectorAll('[data-contact-fade]');

  if (!('IntersectionObserver' in window)) {
    elements.forEach(function(el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  elements.forEach(function(el, index) {
    el.style.transitionDelay = (index * 120) + 'ms';
    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();
})();
